/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-12-27 16:20:35
 * @LastEditors: linxi
 * @LastEditTime: 2023-02-24 10:56:06
 */
import { Space, Switch, TableColumnType } from 'antd'
import React, { ReactElement, useState } from 'react'
import femaleHead from '../../images/female.png'
import maleHead from '../../images/male.png'
import { Dimen } from '../../models/dimen'

type ActionType = 'edit' | 'removeBinding' | 'resctBinding'

export const columns = (
  onClick: (action: ActionType, v: any, state?: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  const [checked, setChecked] = useState<any>()
  return [
    {
      title: '序号',
      key: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '机构名称',
      dataIndex: 'name',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.name ? r.name : '-'
      },
    },

    {
      title: '联系人',
      dataIndex: 'contactName	',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.contactName ? r.contactName : '-'
      },
    },

    {
      title: '联系电话',
      dataIndex: 'phone',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.phone ? r.phone : '-'
      },
    },
    {
      title: '所属区域',
      dataIndex: 'jobTitle',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.provinceName + r?.cityName + r?.countyName
      },
    },

    {
      title: '备注',
      dataIndex: 'comment',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.comment ? r.comment : '-'
      },
    },
    {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r.status == 0 ? '正常' : r.status == 1 ? '已解绑' : '-'
      },
    },
    {
      title: '操作',
      key: 'actions',
      width: '6rem',
      align: 'center',
      render: function UserSettings(_, u): ReactElement {
        return (
          <>
            {u.status == 0 ? (
              <a
                onClick={() => onClick('removeBinding', u)}
                style={{ marginRight: '4px',color:"red" }}
              >
                解除绑定
              </a>
            ) : u.status == 1 ? (
              <a
                onClick={() => onClick('resctBinding', u)}
                style={{ marginRight: '4px' }}
              >
                重新绑定
              </a>
            ) : (
              ''
            )}
          </>
        )
      },
    },
  ]
}
